
import { Layout } from "@/components/Layout/Layout";

export default function RefundPolicy() {
  return (
    <Layout>
      <div className="container max-w-4xl py-12 px-4 mx-auto animate-fade-in">
        <h1 className="text-3xl font-bold mb-6">Refund & Cancellation Policy</h1>
        
        <div className="prose prose-sm sm:prose max-w-none">
          <p className="lead">At ThePromptSpace, we strive to provide a seamless experience to all our users. Please review our refund and cancellation policy outlined below.</p>
          
          <h2 className="flex items-center">
            <span className="mr-2">🎁</span> Donations
          </h2>
          <p>All donations made through our platform are considered voluntary and non-refundable. Since these are acts of goodwill to support our community and development efforts, we do not process refunds for donations once they are successfully completed.</p>
          
          <h2 className="flex items-center">
            <span className="mr-2">🔁</span> Subscriptions
          </h2>
          <p>Our subscription plans provide users with access to exclusive features, content, or community perks. By subscribing, users agree to the following:</p>
          <ul>
            <li>You may cancel your subscription at any time from your account settings or by contacting our support team.</li>
            <li>Cancellations will stop future renewals. However, no partial refunds will be issued for the remaining period of your current billing cycle.</li>
            <li>If you've been charged incorrectly or experience technical issues, you may contact us within 7 days of the transaction for a refund review.</li>
          </ul>
          
          <h2 className="flex items-center">
            <span className="mr-2">📩</span> Contact for Support
          </h2>
          <p>If you need help or would like to request a cancellation, reach out to us at:</p>
          <ul>
            <li>Email: <a href="mailto:thepromptspace@gmail.com" className="text-primary hover:underline">thepromptspace@gmail.com</a> or <a href="mailto:contact.thepromptspace@protonmail.com" className="text-primary hover:underline">contact.thepromptspace@protonmail.com</a></li>
            <li>Subject: "Refund/Cancellation Request"</li>
          </ul>
          
          <h2>Additional Information</h2>
          <p>For premium subscribers, the following additional terms apply:</p>
          <ul>
            <li>Premium features access will remain active until the end of your current billing period after cancellation.</li>
            <li>Any group chats or collections created during your premium subscription will remain accessible but may have limited functionality after your subscription ends.</li>
            <li>Custom prompt templates generated during your subscription period will remain in your library even after subscription cancellation.</li>
          </ul>
          
          <p className="mt-4">We reserve the right to modify this policy at any time, and all changes will be updated on this page.</p>
          
          <p className="text-sm text-muted-foreground mt-8">Last updated: April 12, 2025</p>
        </div>
      </div>
    </Layout>
  );
}
